import '../Assets/css/Empresa.css';

export const Empresa = () => {
    return (
        <div className="company-profile" id='nosotros'>
            <div className="company-container">
                <div className="company-text">
                    <h1>Pluss Minería</h1>
                    <p>Pluss Minería es una empresa de transporte de pasajeros que se destaca por ofrecer un servicio de
                        excelencia en el transporte del personal. Nuestro norte es prestar un servicio de calidad y
                        cubrir
                        todas las necesidades del cliente, dando la mejor experiencia de viaje, y seguridad. Esto lo
                        logramos a través de los más altos estándares de calidad, comodidad y seguridad, respaldados por
                        los
                        sistemas tecnológicos más modernos que tenemos disponibles en nuestra flota.</p>
                    <br/>
                    <p>En Pluss Minería, nos comprometemos a superar las expectativas de nuestros clientes y a brindar
                        un
                        servicio de transporte de pasajeros de calidad, seguro y eficiente. Confíe en nuestra
                        experiencia
                        para cubrir todas sus necesidades de transporte y garantizar un traslado excepcional en cada
                        kilómetro.</p>
                </div>
            </div>
        </div>
    )
}